import { useEffect, useRef, useState } from "react";
import { TaxRatesViewModel } from "../../../viewmodels/setup/taxRates/TaxRatesViewModel";
import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";
import { withRouter } from "../../../shared/utility";
import SlideOver from "../../../components/slideOver/SlideOver";
import EmptyModal from "../../../components/modals/EmptyModal";
import AuditActionLink from "../../../components/audit/AuditActionLink";
import { auditHistoriesSetupAction } from "../../../components/audit/auditEntityConfig";
import {
  SetupActions,
  SetupPage,
  SetupTable,
  SetupTd,
} from "../../../components/setup/SetupPage";

function formatRate(rate) {
  const parsed = parseFloat(rate);
  if (Number.isNaN(parsed)) {
    return rate;
  }
  return `${parsed}%`;
}

function TaxRates(props) {
  const { addSnackbar, logout } = props;
  const {
    emptyModal,
    setEmptyModelOpen,
    getTaxRates,
    loading,
    taxRates,
    openAddTaxRateSlideOver,
    setSlideOver,
    slideOver,
    viewTaxRateDetails,
    askDeleteTaxRate,
  } = TaxRatesViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    getTaxRates(null, currentPage);
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);
  const searchRef = useRef();

  const handleSearch = () => {
    getTaxRates(searchRef.current.value, currentPage);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getTaxRates(searchRef.current.value, currentPage);
  };

  return (
    <div>
      <SetupPage
        title="Tax Rates"
        description="Manage tax rates assigned to suppliers and supplier items."
        searchPlaceholder="Search tax rates by name"
        searchRef={searchRef}
        onSearch={handleSearch}
        actions={[
          { label: "Add Tax Rate", onClick: openAddTaxRateSlideOver },
          auditHistoriesSetupAction("tax-rate"),
        ]}
        loading={loading}
        tableColumns={["Name", "Rate"]}
        totalRecords={taxRates.total}
        first={first}
        rows={rows}
        onPageChange={handlePagination}
      >
        <SetupTable columns={["Name", "Rate"]} emptyText="No tax rates found.">
          {taxRates.data?.map((item, index) => (
            <tr key={item.id} className="transition hover:bg-[#F6F8FB]/80">
              <SetupTd muted={false}>{item.name}</SetupTd>
              <SetupTd muted={false}>{formatRate(item.rate)}</SetupTd>
              <SetupActions>
                <AuditActionLink slug="tax-rate" id={item.id} name={item.name} />
                <button
                  type="button"
                  onClick={() => viewTaxRateDetails(item, index)}
                  className="inline-flex min-w-[68px] justify-center rounded-lg border border-[#E2E8F0] bg-white px-3 py-1.5 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
                >
                  Edit
                </button>
                <button
                  type="button"
                  onClick={() => askDeleteTaxRate(item, index)}
                  className="ml-2 inline-flex min-w-[68px] justify-center rounded-lg border border-[#FECACA] bg-white px-3 py-1.5 text-sm font-semibold text-[#DC2626] shadow-sm transition hover:border-[#FCA5A5] hover:bg-[#FEF2F2]"
                >
                  Delete
                </button>
              </SetupActions>
            </tr>
          ))}
        </SetupTable>
      </SetupPage>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TaxRates));
